export default __webpack_public_path__ + "static/media/5279120_play_video_youtube_youtuble logo_icon.01beee9b.svg";